<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-if="$route.params.id !== undefined"
          variant="outline-primary"
          :to="{ name: 'users-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
        <span v-else />
      </template>
    </app-breadcrumb>
    <b-card aria-hidden="true">
      <b-tabs
        v-if="userData"
        pills
      >
        <!-- Tab: Account -->
        <b-tab active>
          <template #title>
            <feather-icon
              icon="UserIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline"> {{ $t('Account Settings') }}</span>
          </template>

          <user-edit-tab-account
            :user-data="userData"
            :positions-data="positionsData"
            :departments-data="departmentsData"
            class="mt-2 pt-75"
          />

        </b-tab>

        <!-- Tab: Information -->
        <b-tab>
          <template #title>
            <feather-icon
              icon="SettingsIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('Roles') }}</span>
          </template>
          <user-edit-tab-information
            :roles-data="rolesData"
            :user-data="userData"
            :user-id="userData.id"
            class="mt-2 pt-75"
          />
        </b-tab>

        <!-- Tab: Social -->
        <b-tab>
          <template #title>
            <feather-icon
              icon="Share2Icon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Kết nối mạng xã hội</span>
          </template>
          <user-edit-tab-social
            class="mt-2 pt-75"
            :user-data="userData"
            :user-id="userData.id"
          />
        </b-tab>
        <!-- Tab: Change Password -->
        <b-tab>
          <template #title>
            <feather-icon
              icon="LockIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('Change Password') }}</span>
          </template>
          <user-edit-tab-change-password
            :user-data="userData"
            class="mt-2 pt-75"
          />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BOverlay, BButton,
} from 'bootstrap-vue'
import {
  ref,
} from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import UserEditTabAccount from './UserEditTabAccount.vue'
import UserEditTabInformation from './UserEditTabInformation.vue'
import UserEditTabSocial from './UserEditTabSocial.vue'
import UserEditTabChangePassword from './UserEditTabChangePassword.vue'

export default {
  components: {
    AppBreadcrumb,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BOverlay,
    BButton,
    UserEditTabAccount,
    UserEditTabInformation,
    UserEditTabSocial,
    UserEditTabChangePassword,
  },
  setup() {
    const loading = ref(true)
    const userData = ref(null)
    const userId = ref(null)
    const departmentsData = ref([])
    const positionsData = ref([])
    const rolesData = ref([])
    // const rdata = reactive({ tabIndex: 0 })

    store.dispatch('users/fetchUser', { id: router.currentRoute.params.id })
      .then(response => {
        if (response.status === 200) {
          userData.value = response.data.data
          loading.value = false
        }
      })

    store.dispatch('users/fetchPositions')
      .then(response => { positionsData.value = response.data.data })

    store.dispatch('users/fetchDepartments')
      .then(response => {
        if (response.status === 200) {
          const items = response.data.data;
          items.forEach((root) => {
            const item = {
              id: root.id,
              label: root.name,
              children: [],
            };
            if (root.childrens.length) {
              root.childrens.forEach((c1) => {
                const item1 = {
                  id: c1.id,
                  label: c1.name,
                  children: [],
                }
                if (c1.childrens.length) {
                  c1.childrens.forEach((c2) => {
                    const item2 = {
                      id: c2.id,
                      label: c2.name,
                      children: [],
                    }
                    if (c2.childrens.length) {
                      c2.childrens.forEach((c3) => {
                        const item3 = {
                          id: c3.id,
                          label: c3.name,
                          children: [],
                        }
                        if (c3.childrens.length) {
                          c3.childrens.forEach((c4) => {
                            const item4 = {
                              id: c4.id,
                              label: c4.name,
                              children: [],
                            }
                            if (c4.childrens.length) {
                              c4.childrens.forEach((c5) => {
                                const item5 = {
                                  id: c5.id,
                                  label: c5.name,
                                  children: [],
                                }
                                item4.children.push(item5);
                              })
                            }
                            item3.children.push(item4);
                          })
                        }
                        item2.children.push(item3);
                      })
                    }
                    item1.children.push(item2);
                  })
                }
                item.children.push(item1);
              })
            }
            departmentsData.value.push(item);
          });
        }
      })

    store.dispatch('users/fetchRoles')
      .then(response => {
        if (response.status === 200) {
          rolesData.value = response.data.data
        }
      })

    return {
      loading,
      userData,
      departmentsData,
      positionsData,
      rolesData,
      userId,
    }
  },
}
</script>

<style></style>
